import styled, { keyframes } from 'styled-components';
import { useEffect, useState } from 'react';

export const GoatOverlay = ({ canFade }) => {
  const [isVisible, setIsVisble] = useState(true);
  const [isBackgroundVisible, setIsBackgroundVisible] = useState(true);

  useEffect(() => {
    async function fadeGoatOverlay() {
      await new Promise((resolve) => {
        const timeoutId = setTimeout(() => {
          setIsVisble(false);
          clearTimeout(timeoutId);
          resolve(true);
        }, 300);
      }).then(() => {
        const timeoutId = setTimeout(() => {
          setIsBackgroundVisible(false);
          clearTimeout(timeoutId);
          return true;
        }, 100);
      });
    }
    if (canFade && isVisible) {
      // fadeOverlay
      void fadeGoatOverlay();
    }
    // only fade when layout is ready
    // and background calls are finished
    // namely the experiments setup useEffect in pagelayout
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [canFade]);

  return (
    <GoatOverlay.Container data-qa="goat_overlay" $isVisible={isBackgroundVisible}>
      <GoatOverlay.ImageContainer $isVisible={isVisible}>
        <GoatOverlay.Image
          alt="goat logo"
          data-qa="overlay_goat_image"
          src="/images/goat_big.png"
        />
      </GoatOverlay.ImageContainer>
    </GoatOverlay.Container>
  );
};

const shrink = keyframes`
 0% {
        transform:scale(1);
        opacity: 1;
  }
  17% {
    opacity: 1;
  }
    100% {
        transform:scale(0.5);
        opacity: 0;
    }
`;

GoatOverlay.Container = styled.div<{ $isVisible: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  height: 100vh;
  width: 100vw;
  background: ${({ theme }) => theme.colors.black};
  z-index: ${({ $isVisible, theme }) =>
    $isVisible ? theme.zIndex.pageOverlay : theme.zIndex.homepageHeaderBefore};
  opacity: ${({ $isVisible }) => ($isVisible ? 1 : 0)};
  transition: all 0.1s ease-out;

  @media (min-width: ${({ theme }) => theme.breakpoints.mediumSmall}px) {
    max-width: 100%;
  }
`;

GoatOverlay.ImageContainer = styled.div<{ $isVisible: boolean }>`
  width: 88px;
  animation: ${shrink} 1s linear;
  opacity: 0;

  @media (min-width: ${({ theme }) => theme.breakpoints.mediumSmall}px) {
    width: 10vw;
  }
`;

GoatOverlay.Image = styled.img``;
